/* Reopens Shopify's existing preferences UI. No consent is collected here. */
(function () {
  'use strict';
  var button = document.querySelector('[data-fp-cookie-preferences]');
  if (!button || button.dataset.fpCookieBound) return;
  button.dataset.fpCookieBound = 'true';
  var status = document.getElementById(button.getAttribute('aria-describedby'));
  var attempts = 0;
  function getBanner() {
    return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function'
      ? window.privacyBanner : null;
  }
  function enableWhenReady() {
    if (getBanner()) {
      button.hidden = false;
      return;
    }
    if (++attempts < 30) window.setTimeout(enableWhenReady, 500);
  }
  button.addEventListener('click', function () {
    var banner = getBanner();
    if (status) status.textContent = '';
    function unavailable() {
      if (status) status.textContent = button.dataset.unavailable;
    }
    if (!banner) { unavailable(); return; }
    try {
      Promise.resolve(banner.showPreferences()).catch(unavailable);
    } catch (error) { unavailable(); }
  });
  enableWhenReady();
})();
